import React from 'react';
import './Content.css';

import OptOut from '../OptOut/OptOut';

const Content = props => (
	<div className="site-content row">
		<OptOut {...props} />
	</div>
);

export default Content;


// WEBPACK FOOTER //
// ./src/components/Content/Content.js